<template>
  <div class="row card animated zoomIn">
    <div class="col s12 m6">
      <button
        class="btn-large waves-effect green darken-2 waves-dark"
        style="width:100%;"
        @click.prevent="login('vendor')"
      >
        BECOME A MERCHANT
      </button>
      <h5>iRecharge Merchant</h5>
      <p class="text-justify">
        Have an existing business and want to make extra income? Tired of saying
        “I don’t have change”? Want to bring value added services to your
        customers and clients at their convenience and no extra cost? Does your
        business have a physical transaction location? Then welcome to irecharge
        biz. <br />
        <strong>iRecharge Biz</strong> is built for the physical
        commodity/service providers that sign up to have the platform integrated
        into their system so as to be able to provide iRecharge products to
        their customers while the payments are recorded on their regular
        point-of-sale software.
      </p>
      <h5>Benefits</h5>
      <ul>
        <li>Offer instant top up as an alternative for change.</li>
        <li>
          Offer value added services to customers such as payments for tv,
          electricity and internet
        </li>
        <li>
          Increased traffic to the location considering the demand for services
          on the platform.
        </li>
        <li>Gain commission on all transactions.</li>
        <li>Supports multi user simultaneous vending</li>
        <li>Increases Business brand Value</li>
        <li>
          Sell flexible airtime amounts between N50 and N40, 000 to <br />any
          postpaid or pre-paid line.
        </li>
        <li>Vend airtime to CUG lines</li>
        <li>Free branding and training materials</li>
        <li>Increase average revenue per customer</li>
        <li>Increase customer retention propensity</li>
      </ul>
      <h5>Click to download</h5>
      <p class="text-left"><strong>Available Downloads</strong></p>
      <ul>
        <li>
          <a
            class="text-success"
            href="admin_controller/includes/download.php?f=admin_controller/generalItem/PageFiles/1.pdf&amp;fc=IRECHARGE VENDOR BROCHURE web.pdf"
            >iRecharge Vendor Brochure</a
          >
        </li>
        <li>
          <a
            class="text-success"
            href="admin_controller/includes/download.php?f=admin_controller/generalItem/PageFiles/4.pdf&amp;fc=BIZ BROCHURE UPDATE.pdf"
            >iRecharge Brochure</a
          >
        </li>
        <li>
          <a
            class="text-success"
            href="downloadable/iRecharge_Install_05_2019.zip"
            >iRecharge Desktop App (Legacy)</a
          >
        </li>
        <li>
          <a class="text-success" href="downloadable/desktop/32bit/iRecharge%20Setup%200.1.5.exe"
            >iRecharge Desktop App (32 bit)</a
          >
        </li>
        <li>
          <a class="text-success" href="downloadable/desktop/64bit/iRecharge%20Setup%200.1.5.exe"
            >iRecharge Desktop App (64 bit)</a
          >
        </li>
      </ul>
      <button
        class="btn-large waves-effect green darken-2 waves-dark"
        style="width:100%;"
        @click.prevent="login('vendor')"
      >
        BECOME A MERCHANT
      </button>
    </div>
    <solution-part />
  </div>
</template>
<script>
import SolutionPart from '@/components/partials/SolutionPart.vue'
export default {
  name: 'iRechargeBiz',
  components: {
    SolutionPart
  },
  mounted() {
    this.startCarousel()
  },
  data() {
    return {}
  },
  methods: {
    startCarousel() {
      var owlClients = $('#owlClients')
      owlClients.owlCarousel({
        items: 2,
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 1000,
        autoplayHoverPause: true
      })
      var owlTestimonial = $('#owlTestimonial')
      owlTestimonial.owlCarousel({
        items: 1,
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true
      })
    },
    login(option) {
      document.getElementById('myNav').style.width = '100%'
      this.$emit('modal-option', option)
    }
  }
}
</script>
<style scoped>
ul li {
  list-style-type: circle;
  text-align: left;
}
.card {
  padding: 15px 20px;
}
</style>
